import { defineAsyncComponent } from 'vue';
import type { ModularBlockConfig } from '../../../frontend/types';
import { blockPeopleListFields } from './groq';

/** Shared registry entry. Lazy: not on the critical rendering path. */
export const peopleListBlockConfig = {
  name: 'inner-block-people',
  component: defineAsyncComponent(() => import('./CmsPeopleList.vue')),
  innerComponent: defineAsyncComponent(() => import('./PeopleList.vue')),
  fields: blockPeopleListFields,
} satisfies ModularBlockConfig;
